import { render, staticRenderFns } from "./OurExpertise.vue?vue&type=template&id=7ef8c99e&scoped=true&"
import script from "./OurExpertise.vue?vue&type=script&lang=js&"
export * from "./OurExpertise.vue?vue&type=script&lang=js&"
import style0 from "./OurExpertise.vue?vue&type=style&index=0&id=7ef8c99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef8c99e",
  null
  
)

export default component.exports